export default __webpack_public_path__ + "static/media/vladi.d62cb5ea.png";